import React from 'react';
import {
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import axios from 'axios';
import Navigation from './Navigation';
import { dashboardData } from '../data/dashboard';

const classesData = ['CLASS_ONE','CLASS_TWO','CLASS_THREE','CLASS_FOUR','CLASS_FIVE','CLASS_SIX','CLASS_SEVEN']
const intervalData = ['TERMINAL','ANNUAL','MIDTERM','TEST']
const subjectsData = ['MATHEMATICS','HINDI','GENERAL_SCIENCES','SOCIAL_SCIENCE']

const AddGrade = () => {
  const [userType, setUserType] = React.useState('RESULTS');
  const [userData, setUserData] = React.useState({
    name: '',
    email: '',
    password: '',
    role: 'RESULTS',
    dob: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

    if (name === 'role') setUserType(value);
  };


  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userData.password !== userData.confirmPassword)
      return alert('Passwords do not match');

    try {
      const response = await axios.post('/users', userData);
      console.log(response);
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        const { message } = error.response.data;
        return alert('Error: ' + message);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        alert('Error: ' + error.message);
      }

      return alert('Something went wrong, please try again later');
    }
  };

  return (
 <div heading={'Add Assessments Results'}>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '40%',
            padding: '10px',
            margin: 'auto',
          }}
        >
          <h2
            style={{
              alignText: 'center',
              paddingTop: '18px',
              paddingBottom: '18px',
              textAlign: 'center',
              backgroundColor: '#3f51b5',
              color: 'white',
            }}
          >
            Add Assessments Results
          </h2>

          {userType === 'RESULTS' && (
            <FormControl
              fullWidth
              style={{
                marginBottom: '10px',
              }}
            >
            </FormControl>
          )}

          <div
            style={{
              marginBottom: '10px',
            }}
          >
               
          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >
            <InputLabel id='demo-simple-select-label'>Class</InputLabel>
            <Select id='role' name='role' label='Role' onChange={handleChange}>
            {
                //loop over classesData and return a MenuItem for each class
                classesData.map((classData) => {
                    return <MenuItem value={classData}>{classData}</MenuItem>
                }
                )
            }

            </Select>

              

          </FormControl>

          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >
            <InputLabel id='demo-simple-select-label'>Interval</InputLabel>
            <Select id='role' name='role' label='Role' onChange={handleChange}>
            {
                //loop over classesData and return a MenuItem for each class
                intervalData.map((classData) => {
                    return <MenuItem value={classData}>{classData}</MenuItem>
                }
                )
            }

            </Select>

              

          </FormControl>


          <FormControl
            fullWidth
            style={{
              marginBottom: '10px',
            }}
          >
            <InputLabel id='demo-simple-select-label'>Subjects</InputLabel>
            <Select id='role' name='role' label='Role' onChange={handleChange}>
            {
                //loop over classesData and return a MenuItem for each class
                subjectsData.map((classData) => {
                    return <MenuItem value={classData}>{classData}</MenuItem>
                }
                )
            }

            </Select>

              

          </FormControl>
          </div>

          

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='Lecturers ID'
              name='lecturers id'
              type='lecturers id'
              label='Lecturers id'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />
          </div>

       

         

          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <TextField
              id='studentID'
              name='studentID'
              label='studentID'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />


          </div>

          <div
            style={{
              marginBottom: '10px',
            }}
          >

          <TextField
              id='results'
              name='results'
              label='Result in %'
              variant='outlined'
              fullWidth
              required
              onChange={handleChange}
            />

            </div>
          


          <Button type='submit' variant='contained'>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddGrade;
